export default {"src":"/_next/static/media/chevRight.7c22bdd2.svg","height":32,"width":12,"blurWidth":0,"blurHeight":0};